module.exports = {"svg":{"$":{"version":"1.1","id":"图层_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 19.8","style":"enable-background:new 0 0 20 19.8;","xml:space":"preserve"},"path":[{"$":{"d":"M1.3,17.8h17.8v2H1.3V17.8L1.3,17.8z M17.8,12.5h-4.3c-0.4-0.5-0.7-1-0.7-1.6c-0.2-2.4,2.4-3.5,2.4-6.5\r\n\tC15.1,2,13.2,0,10.2,0c-3,0-4.9,2-4.9,4.5c0,2.9,2.6,4.1,2.4,6.5c0,0.6-0.3,1.1-0.7,1.6H2.6c-0.7,0-1.3,0.6-1.3,1.3v2.6h17.8v-2.6\r\n\tC19.1,13.1,18.5,12.5,17.8,12.5z"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/assets/svg/approve.svg
// module id = AsUp
// module chunks = 1